import KlickrentLogo from '@/public/images/klickrent-logo.svg';

export default function Logo() {
  return <KlickrentLogo />;
}
